const lang = {
  "common.and": "e",
  "common.or": "ou",
  "common.yes": "sim",
  "common.delete": "Excluir",
  "common.loading": "Carregando",
  "common.done": "Pronto",
  "common.close": "Fechar",
  "common.continue": "Continuar",
  "common.accept": "Aceitar",
  "common.property": "Propriedade",
  "common.status": "Status",
  "common.skip": "Pular",
  "common.send": "Enviar",
  "common.pause": "Pausar",
  "common.connecting": "Conectando",
  "common.activate": "Ativar",
  "common.back": "Voltar",
  "common.edit": "Editar",
  "common.active": "Ativo",
  "common.clear": "Limpar",
  "common.manage": "Gerenciar",
  "common.apply": "Aplicar",
  "common.download": "Download",
  "common.setup": "Configurar",
  "common.embed": "Incorporar",
  "common.connect": "Conectar",
  "common.configure": "Configurar",
  "common.call": "Chamada",
  "common.inactive": "Inativo",
  "common.cancel": "Cancelar",
  "common.next": "Próximo",
  "common.previous": "Anterior",
  "common.account": "Conta",
  "common.file": "Arquivo",
  "common.photo": "Fotos",
  "common.emoji": "Emoji",
  "common.runAi": "Executar IA",
  "common.remove": "Remover",
  "common.reset": "Redefinir",
  "common.confirmInactive": "Sim, desativar",
  "common.confirmContinue": "Sim, continuar",
  "common.confirmDelete": "Sim, excluir",
  "common.confirmScan": "Sim, escanear",
  "common.error": "Erro",
  "common.tryItLater": "Ocorreu um erro, tente novamente mais tarde",
  "common.success": "Sucesso",
  "common.regenerate": "Regenerar",
  "common.today": "Hoje",
  "common.week": "Esta semana",
  "common.7days": "Últimos 7 dias",
  "common.30days": "Últimos 30 dias",
  "common.thisMonth": "Este mês",
  "common.lastMonth": "Mês passado",
  "common.custom": "Personalizado",
  "common.all": "Todos",
  "common.date": "Data",
  "common.name": "Nome",
  "common.company": "Conta",
  "common.message": "Mensagem",
  "common.chat": "Chat",
  "common.noResults":
    "Nenhum registro encontrado para o intervalo de datas selecionado",
  "common.results": "{total} resultados",
  "common.body": "Mensagem",
  "common.tags": "Etiquetas",
  "common.save": "Salvar",
  "common.saveClose": "Salvar e fechar",
  "common.submitChanges": "Enviar alterações",
  "common.updating": "Atualizando...",
  "common.newConversation": "Nova conversa",
  "common.create": "Criar",
  "common.phone": "Número de telefone",
  "common.contactName": "Nome do contato",
  "common.optional": "Opcional",
  "common.recommended": "Recomendado",
  "common.signUp": "Cadastrar-se",
  "common.copyLink": "Link copiado",
  "common.copyCode": "Código copiado",
  "common.share": "Compartilhar",
  "common.virtualAssistant": "Assistente Virtual",
  "common.scan": "Digitalize seu site",
  "common.rescan": "Re-digitalizar",
  "common.add": "Adicionar",
  "common.setUp": "Configurar",
  "common.typeText": "Digite um texto...",
  "common.connected": "Conectado",
  "common.disconnected": "não conectado",
  "common.searchText": "Buscar no texto...",
  "common.characteres": "caracteres",
  "common.wordpress": "WordPress",
  "common.seeMessage": "Ver mensagem",
  "common.analyze": "Analisar",
  "common.filter": "Filtrar",
  "common.filterConvs": "Filtrar chats",
  "common.reviewNow": "Revisar agora",
  "common.analyzedOn": "Última análise {date}",
  "common.available": "Disponível",
  "common.activeConfig": "Configuração ativa",
  "common.invalidDomain":
    "Este site não é válido. Insira um domínio permitido.",

  "settings.pageTitle": "Configurações",
  "settings.pageDescription": "Ajuste suas preferências",
  "settings.ai": "Configurações de IA",
  "settings.accountTitle": "Conta",
  "settings.language": "Idioma",
  "settings.company": "Informações da empresa",
  "settings.company.desc":
    "Atualize as informações da sua empresa, como nome, telefone ou detalhes gerais",
  "settings.settingsTitle": "Configurações",
  "settings.channels": "Canais",
  "settings.connect": "Conectar",
  "settings.api": "Chaves API",
  "settings.integrations": "Integrações",
  "settings.teams": "Equipe",
  "settings.payment": "Cobrança",
  "settings.usage": "Uso",
  "settings.pushNotificationsDescription":
    "Controle as notificações push no seu dispositivo",
  "settings.pushNotificationsDenied":
    "As notificações estão desativadas. Ative-as nas configurações do dispositivo para receber atualizações.",
  "esc.needsReview": "Revisão",
  "esc.escalation": "Ajuda",
  "esc.clickToView": "Clique para ver",
  "esc.tapToView": "Toque para ver",
  "esc.solve": "Resolver a escalada",
  "support.liveChat": "Chat ao Vivo",
  "support.guide": "Ler Documentação",
  "support.email": "Enviar Email",
  "support.call": "Agendar Chamada",
  "nav.inbox": "Conversas",
  "nav.leads": "Leads",
  "nav.integrations": "Integrações",
  "nav.home": "Início",
  "nav.outbound": "Eventos",
  "nav.ai": "IA",
  "nav.aiSetup.progress": "Setup {completed}/3",
  "nav.aiSetup.title": "Configuração da conta",
  "nav.aiSetup.progressSummary": "{completed} de {total} concluídos",
  "nav.aiSetup.progressSummary.blocked":
    "{completed} de {total} concluídos • Conecte um canal para entrar ao vivo.",
  "nav.aiSetup.popover.title": "Conclua a configuração da IA",
  "nav.aiSetup.popover.subtitle": "Conclua estas etapas para entrar ao vivo.",
  "nav.aiSetup.completed.title": "Configuração concluída",
  "nav.aiSetup.completed.subtitle":
    "Sua IA já está ao vivo em pelo menos um canal.",
  "nav.aiSetup.completed.cta": "Ir para Conversas",
  "nav.aiSetup.item.knowledge": "Conhecimento",
  "nav.aiSetup.item.knowledge.desc":
    "É assim que você treina sua IA: adicione site, texto ou arquivos.",
  "nav.aiSetup.item.integrations": "Integrações",
  "nav.aiSetup.item.integrations.desc":
    "Conecte seu provedor para enriquecer respostas.",
  "nav.aiSetup.item.channels": "Canais",
  "nav.aiSetup.item.channels.desc":
    "Conecte pelo menos um canal para entrar ao vivo.",
  "nav.aiSetup.item.teamMembers": "Membros da equipe",
  "nav.aiSetup.item.teamMembers.desc":
    "Convide sua equipe para ajudar no atendimento das conversas.",
  "nav.aiSetup.item.mobileApps": "Apps móveis",
  "nav.aiSetup.item.mobileApps.desc":
    "Instale o app da Visito para receber notificações push.",
  "nav.aiSetup.action.go": "Ir",
  "nav.whatsNew.trigger": "Novidades",
  "nav.whatsNew.title": "Novidades no Visito",
  "nav.whatsNew.subtitle": "Atualizações recentes para sua equipe.",
  "nav.whatsNew.new": "Novo",
  "nav.whatsNew.item.cta": "Abrir",
  "nav.whatsNew.item.setup.title": "Progresso da configuração",
  "nav.whatsNew.item.setup.desc":
    "Acompanhe seu onboarding direto pela barra de navegação.",
  "nav.whatsNew.item.playground.title": "Prompts rápidos no Playground",
  "nav.whatsNew.item.playground.desc":
    "Use prompts sugeridos por contexto para testar sua IA mais rápido.",
  "nav.whatsNew.item.team.title": "Membros da equipe no mobile",
  "nav.whatsNew.item.team.desc":
    "Gerencie convites e funções nas configurações móveis.",
  "nav.whatsNew.item.mobile.title": "Notificações móveis",
  "nav.whatsNew.item.mobile.desc":
    "Instale o app móvel para acompanhar novas conversas.",
  "nav.whatsNew.item.itemsCatalog.title": "Catálogo de itens para vendas diretas",
  "nav.whatsNew.item.itemsCatalog.desc":
    "Crie itens como day pass ou massagem, adicione detalhes obrigatórios e deixe a IA cobrar com links de pagamento no chat.",
  "nav.whatsNew.item.followUps.title": "Controles de acompanhamento",
  "nav.whatsNew.item.followUps.desc":
    "Agora você pode definir quanto tempo a IA espera antes de revisar chats inativos e quão agressivo será o acompanhamento (Alta, Padrão ou Baixa) conforme o impacto da conversa.",
  "nav.whatsNew.item.igDocs.title": "Envio de documentos no Instagram",
  "nav.whatsNew.item.igDocs.desc":
    "Agora você pode enviar documentos do Visito para o Instagram como anexos no chat.",
  "nav.whatsNew.item.mobileTeam.title": "Gerencie membros da equipe pelo app",
  "nav.whatsNew.item.mobileTeam.desc":
    "Convide e gerencie sua equipe diretamente no Visito mobile.",
  "nav.whatsNew.item.mobileTeam.android": "Baixar para Android",
  "nav.whatsNew.item.mobileTeam.ios": "Baixar para iOS",
  "nav.crm": "CRM",
  "nav.payments": "Pagamentos",
  "nav.channels": "Canais",
  "nav.items": "Itens",
  "nav.settings": "Configurações",
  "nav.logout": "Sair",
  "nav.menu": "Menu",
  "nav.limitApproaching": "Seus créditos estão acabando.",

  "nav.notificationsToolTip":
    "Controle os sons de alerta e as notificações de desktop.",

  "nav.notifications": "Notificações",

  "nav.channelOnboarding": "Precisa de ajuda?",
  "nav.channelOnboardingCTA": "Agende uma chamada",
  "nav.payment": "Você usou todos os seus créditos de mensagens.",
  "nav.paymentCTA": "Obter mais créditos",
  "nav.accountList": "Contas",
  "nav.pastDue": "Seu pagamento falhou.",
  "nav.pastDueCTA":
    "Atualize seu método de pagamento para manter sua conta ativa.",
  "nav.connect": "Conectar",
  "nav.createAccount": "Criar nova conta",
  "nav.helpCenter": "Centro de Ajuda",
  "nav.helpChat": "Chat de Ajuda",
  "ai-settings.workingHours": "Horário de trabalho",
  "ai-settings.workingHoursDescription":
    "Se uma escalonamento ocorrer fora do horário de expediente, a IA informará o hóspede sobre o horário de atendimento.",
  "ai-settings.title": "Configurações de IA",
  "ai-settings.paneTitle": "Configurações de Inteligência Artificial",
  "ai-settings.notifications": "Notificações",
  "ai-settings.notificationsDescription":
    "Baixe o aplicativo Visito para receber notificações push sobre conversas não resolvidas.",
  "ai-settings-intructions.title": "Configurações",
  "ai.pageTitle": "Inteligência Artificial",
  "ai.pageDescription": "Ajuste e experimente seu agente de IA",
  "ai.contextTitle": "Base de Conhecimento",
  "ai.contextDescription":
    "Gerencie seu conhecimento para treinar seu agente de IA",
  "ai.playgroundTitle": "Sandbox do Agente de IA",
  "ai.playgroundDescription":
    "Interaja com seu agente de IA para observar como ele responde",
  aiSettingsWorking: "Estamos preparando suas informações",
  aiSettingsOptimizing: "Estamos otimizando suas informações",
  aiSettingsOptimizingDesc:
    "Estamos otimizando as informações extraídas de seu site",
  aiSettingsKnowledge: "Hub de IA",
  aiSettingsKnowledgeDesc:
    "Aqui você pode fornecer informações para treinar a IA. Teste a IA à direita para ver o que seus clientes experimentarão.",
  aiSettingsAlert:
    "Aqui você pode fornecer informações para treinar a IA. Teste a IA à direita para ver o que seus clientes experimentarão.",
  aiSettingsFreeText: "Texto livre",

  aiSettingsReset: "Limpar",
  aiSettingsCall: "Chamada",
  aiSettingsCalling: "Chamando",
  aiSettingsCallConnected: "Conectado",
  aiSettingsMicPermission: "Permita o acesso ao microfone para continuar",

  aiSettingsHangup: "Desligar",
  aiSettingsAssitant: "Conheça Lana! Sua assistente virtual",
  aiSettingsAssitantDesc:
    "Aqui você pode experimentar e interagir com Lana para entender exatamente o que seus clientes experimentarão com as respostas da IA.",
  aiCrawlingFailed:
    "Houve um problema ao analisar seu site, tente novamente mais tarde",
  aiCrawlingSkip: "Deseja continuar sem analisar seu site?",
  aiCrawlingSkipDesc:
    "Analisar seu site ajudará seu assistente de IA a oferecer melhores resultados",
  aiSettingsSaving: "Salvando alterações...",
  aiExceededLength: "Você excedeu o limite de caracteres",
  aiCompanyTitle: "{company}",
  aiPoweredBy: "Desenvolvido por",
  aiCompanyWelcomeTitle: "Bem-vindo ao assistente virtual da {company}",
  aiCompanyFormDesc: "Insira seu nome para começar",
  aiCompanyExplore: "Continuar",
  aiShare: "Compartilhe seu assistente virtual",
  aiCrawl: "Vamos escanear seu site e treinar seu agente de IA!",
  aiCrawling: "Sua IA está escaneando o site",
  aiCrawlingWebsiteSucc: "Análise do site concluída",
  aiCrawlingSuccess: "Seu site foi escaneado com sucesso",
  aiCrawlingSuccessDesc: "Suas informações estão prontas para revisão.",
  aiReview: "Vamos revisá-las",
  aiAgent: "Agente de IA",
  aiAgentCreated: "Seu agente de IA está pronto",
  aiUpdateCta: "Editar",
  aiUpdateSucces: "Seu agente de IA foi atualizado",
  aiGeneralContext: "Informações gerais",
  aiProviderContext: "Informações do fornecedor",

  "ai.agent.title": "Seu Agente de IA",
  "ai.agent.description":
    "Este é o núcleo central. Sua função é conectar todas as partes do seu ecossistema em tempo real:",

  "ai.agent.feature.knowledge":
    "Consulta sua base de conhecimento para encontrar respostas.",
  "ai.agent.feature.behavior":
    "Segue suas configurações de personalidade, tom de voz e regras de negócio.",
  "ai.agent.feature.integrations":
    "Executa ações externas, como verificar disponibilidade.",
  "ai.agent.feature.channels":
    "Entrega a resposta final ao cliente pelos seus canais.",
  "ai.onboarding.profile.title": "Conte-nos sobre você",
  "ai.onboarding.profile.desc":
    "Insira seu nome e número de telefone para configurar sua conta",
  "ai.onboarding.profile.phoneNumber": "Número de telefone",
  "ai.onboarding.profile.invalidPhone":
    "Por favor, insira um número de telefone válido",
  "ai.onboarding.profile.name": "Nome completo",
  "ai.onboarding.title": "Crie seu agente de IA",
  "ai.onboarding.desc":
    "Informe o site e para que a IA aprenda sobre o seu negócio.",
  "ai.onboarding.cta": "Criar Agente",
  "ai.onboarding.cta.skip": "Pular, configurar manualmente",
  "ai.onboarding.error":
    "Não foi possível analisar seu site. Tente novamente com outra URL ou continue com a configuração manual.",
  "ai.onboarding.preview.support":
    "Olá! 👋 Estou aqui para ajudar com qualquer dúvida ou problema. Como posso te ajudar hoje?",
  "ai.onboarding.preview.sales":
    "Olá! 👋 Procurando as melhores ofertas? Posso te mostrar opções que combinam com o que você precisa. 🚀",
  "ai.onboarding.preview.booking":
    "Bem-vindo 👋 Gostaria de verificar disponibilidade, fazer uma reserva ou pedir assistência? Estou aqui para ajudar. 🛎️",
  "ai.onboarding.preview.ecommerce":
    "Olá 👋 Está procurando algo específico? Posso te ajudar a encontrar o produto ideal. 🛍️",
  "ai.onboarding.preview.internal":
    "Olá, equipe 👋 Precisam de apoio com processos internos ou informações específicas? Estou aqui para ajudar.",
  "ai.onboarding.preview.education":
    "Olá 👋 Qual tema você gostaria de aprender ou revisar hoje? Posso te explicar passo a passo. 🎓",
  "ai.onboarding.preview.other":
    "Olá 👋 Sou seu assistente virtual. Como posso te ajudar hoje?",
  "ai.onboarding.agent.preview": "É assim que seus clientes verão seu agente",
  "ai.onboarding.agent.learn": "Vou aprender com: ",
  "ai.onboarding.agent.online": "Online",
  "ai.onboarding.agent.processing": "Processando",
  "ai.onboarding.building": "Construindo seu Agente",
  "ai.onboarding.type.title": "O que você quer que seu agente faça?",
  "ai.onboarding.type.description":
    "Defina como seu agente ajudará o seu negócio.",
  "ai.onboarding.company.description":
    "Revise e edite o contexto da sua empresa antes de criar seu agente.",
  "ai.onboarding.companyName.label": "Nome da empresa",
  "ai.onboarding.companyName.placeholder": "VISITO AI",
  "ai.onboarding.companyName.required": "O nome da empresa é obrigatório.",
  "ai.onboarding.aboutCompany.label": "Sobre a empresa",
  "ai.onboarding.aboutCompany.placeholder":
    "Resuma o que sua empresa faz, seus produtos/serviços e sua proposta de valor.",
  "ai.onboarding.aboutCompany.required":
    "A descrição da empresa é obrigatória.",
  "ai.onboarding.company.contextHelp":
    "Seu agente será treinado com esses dados. Você pode adicionar mais contexto depois.",
  "ai.onboarding.type.support.label": "Atendimento ao Cliente",
  "ai.onboarding.type.support.desc": "Resolve dúvidas frequentes 24/7.",
  "ai.onboarding.type.sales.label": "Vendas e Leads",
  "ai.onboarding.type.sales.desc": "Captura e qualifica clientes em potencial.",
  "ai.onboarding.type.booking.label": "Reservas",
  "ai.onboarding.type.booking.desc": "Gerencia agenda e disponibilidade.",
  "ai.onboarding.type.ecommerce.label": "Assistente de Compras",
  "ai.onboarding.type.ecommerce.desc": "Guia sobre produtos e catálogo.",
  "ai.onboarding.type.internal.label": "Uso Interno / RH",
  "ai.onboarding.type.internal.desc": "Manuais, processos e dúvidas da equipe.",
  "ai.onboarding.type.education.label": "Educação",
  "ai.onboarding.type.education.desc": "Explica cursos ou conteúdos.",
  "ai.onboarding.type.other.label": "Outro / Personalizado",
  "ai.onboarding.type.other.desc": "Defina suas próprias regras.",
  "ai.onboarding.extraPlaceholder":
    "Descreva como você quer que seu agente funcione (opcional)",
  "ai.viz.title": "Treinamos seu agente com o seu site",
  "ai.viz.description": "A IA aprende com seu conteúdo para responder melhor",

  "ai.connect.title": "Conectar",
  "ai.connect.desc":
    "Conecte sua IA a um canal como WhatsApp, Instagram ou Messenger.",
  "ai.connect.status": "Sua IA não está conectada a nenhum canal",
  "ai.connect.cta": "Conectar sua IA",
  "ai.onboarding.sourceNotice":
    "Você poderá adicionar mais fontes de dados depois.",
  "ai.onboarding.readingWebsite": "Lendo seu site",
  "ai.onboarding.teachingAgent": "Ensinando seu agente",
  "ai.onboarding.creatingAgent": "Preparando seu agente",
  "ai.agent": "Seu Agente de IA",
  "ai.agent.update": "Aplicar Alterações",
  "ai.playground": "Teste",
  "ai.playground.onboarding": "Testar",
  "ai.playground.desc": "Teste seu agente de IA em um chat de exemplo",
  "ai.playground.test": "Testar sua IA",
  "ai.playground.trained": "Sua IA está pronta.",
  "ai.playground.notTrained":
    "Sua IA ainda não foi treinada. Adicione fontes de treinamento para que ela possa começar a responder perguntas sobre o seu negócio.",

  "ai.playground.help.title": "Playground",
  "ai.playground.help.subtitle":
    "Interaja com o seu agente exatamente como seus clientes fariam.",
  "ai.playground.help.status.title": "Sincronizado e pronto",
  "ai.playground.help.status.desc":
    "O agente tem acesso total à sua Base de Conhecimento, às configurações de Comportamento e às Integrações ativas.",
  "ai.playground.help.suggestions.title": "Sugestões de interação",
  "ai.playground.help.suggestions.accuracy.title": "Precisão das respostas",
  "ai.playground.help.suggestions.accuracy.desc":
    "Peça dados específicos (preços, políticas, horários) para validar as fontes.",
  "ai.playground.help.suggestions.tone.title": "Estilo e tom",
  "ai.playground.help.suggestions.tone.desc":
    "Verifique se ele se comunica com a personalidade e o formato definidos nas configurações de comportamento.",
  "ai.playground.help.suggestions.logic.title": "Lógica e ações",
  "ai.playground.help.suggestions.logic.desc":
    "Confirme que ele consegue entender intenções complexas, aplicar regras de negócio e acionar escalonamentos quando necessário.",
  "ai.playground.help.footer":
    "Se você ajustar as configurações, lembre-se de limpar o chat para aplicar as mudanças.",
  "ai.playground.welcome.connect.title": "Entre no ar mais rápido",
  "ai.playground.welcome.connect.subtitle":
    "Conecte canais e integrações para lançar sua IA em conversas reais.",
  "ai.playground.welcome.connect.channels.desc":
    "Conecte onde seus clientes enviam mensagens: WhatsApp, Instagram, Messenger.",
  "ai.playground.welcome.connect.integrations.desc":
    "Conecte provedores para sua IA responder com dados de negócio em tempo real.",
  "ai.playground.welcome.connect.status.connected": "Conectado",
  "ai.playground.welcome.connect.status.notConnected": "Não conectado",
  "ai.playground.welcome.next.title": "Pronto para o próximo passo?",
  "ai.playground.welcome.next.subtitle":
    "Conclua estes passos para finalizar a configuração e começar a operar.",
  "ai.playground.welcome.next.toggle": "Mostrar ou ocultar próximos passos",
  "ai.playground.welcome.next.configure.title": "Configure seu agente de IA",
  "ai.playground.welcome.next.configure.desc":
    "Adicione contexto, regras e fluxos.",
  "ai.playground.welcome.next.configure.cta": "Configurar",
  "ai.playground.welcome.next.channels.title": "Publique sua IA",
  "ai.playground.welcome.next.channels.desc":
    "Lance onde seus clientes enviam mensagens.",
  "ai.playground.welcome.next.channels.cta": "Publicar",
  "ai.playground.welcome.next.integrations.title": "Conecte seus sistemas",
  "ai.playground.welcome.next.integrations.desc":
    "Tome ações e compartilhe dados em tempo real.",
  "ai.playground.welcome.next.integrations.cta": "Conectar",
  "ai.playground.welcome.paywall.title": "Comece seu teste grátis",
  "ai.playground.welcome.paywall.desc":
    "Escolha o melhor plano e desbloqueie canais, integrações e fluxos avançados de IA.",
  "ai.playground.welcome.paywall.perMonth": "/ mês",
  "ai.playground.welcome.paywall.creditOptions": "Opções de créditos",
  "ai.playground.welcome.paywall.creditsOption":
    "{credits, number} créditos / mês",
  "ai.playground.welcome.paywall.includes": "Inclui:",
  "ai.playground.welcome.paywall.mostPopular": "Mais popular",
  "ai.playground.welcome.paywall.starter.title": "Starter",
  "ai.playground.welcome.paywall.starter.desc":
    "Suporte e reservas com IA em todos os seus canais de mensagens.",
  "ai.playground.welcome.paywall.starter.feature.1":
    "Agente de IA para suporte e reservas",
  "ai.playground.welcome.paywall.starter.feature.2":
    "WhatsApp, Instagram e chat do site",
  "ai.playground.welcome.paywall.starter.feature.3":
    "Caixa de entrada compartilhada da equipe",
  "ai.playground.welcome.paywall.starter.feature.4":
    "Integrações profundas",
  "ai.playground.welcome.paywall.starter.feature.5":
    "Disponível em mais de 100 idiomas",
  "ai.playground.welcome.paywall.starter.feature.6":
    "Analytics básico",
  "ai.playground.welcome.paywall.pro.title": "Pro",
  "ai.playground.welcome.paywall.pro.desc":
    "Modelos avançados, análises mais profundas e onboarding dedicado.",
  "ai.playground.welcome.paywall.pro.includes": "Tudo do Starter, mais:",
  "ai.playground.welcome.paywall.pro.feature.1":
    "Acesso a modelos avançados",
  "ai.playground.welcome.paywall.pro.feature.2": "Onboarding dedicado",
  "ai.playground.welcome.paywall.pro.feature.3": "Suporte prioritário",
  "ai.playground.welcome.paywall.pro.feature.4":
    "Analytics e relatórios avançados",
  "ai.playground.welcome.paywall.pro.feature.5":
    "Fluxos de IA personalizados",
  "ai.playground.welcome.paywall.pro.feature.6":
    "Remover marca Visito",
  "ai.playground.welcome.paywall.enterprise.title": "Enterprise",
  "ai.playground.welcome.paywall.enterprise.desc":
    "Fluxos e integrações personalizados para negócios em crescimento.",
  "ai.playground.welcome.paywall.enterprise.custom": "Custom",
  "ai.playground.welcome.paywall.enterprise.includes":
    "Tudo do Pro, mais:",
  "ai.playground.welcome.paywall.enterprise.feature.1":
    "Pacotes de créditos personalizados",
  "ai.playground.welcome.paywall.enterprise.feature.2":
    "Onboarding e desenho de fluxos personalizados",
  "ai.playground.welcome.paywall.enterprise.feature.3":
    "Suporte dedicado e opções de SLA",
  "ai.playground.welcome.paywall.enterprise.feature.4":
    "Integrações personalizadas",
  "ai.playground.welcome.paywall.enterprise.feature.5":
    "Gestão multi-propriedade",
  "ai.playground.welcome.paywall.enterprise.cta": "Solicitar proposta",
  "ai.playground.welcome.paywall.enterprise.intent.channels": "canais",
  "ai.playground.welcome.paywall.enterprise.intent.integrations":
    "integrações",
  "ai.playground.welcome.paywall.enterprise.mail.subject":
    "Contato enterprise pelo welcome ({intent})",
  "ai.playground.welcome.paywall.enterprise.mail.body":
    "Olá, equipe,\n\nQuero preços enterprise para {company}. No momento tenho interesse em {intent}.\n\nPodem me enviar os detalhes?\n",
  "ai.playground.welcome.paywall.cta": "Começar grátis",
  "ai.playground.welcome.paywall.creditsInfo.title":
    "Como os créditos funcionam",
  "ai.playground.welcome.paywall.creditsInfo.body":
    "1 crédito = 1 resposta da IA. Mensagens de clientes e respostas manuais da sua equipe são sempre grátis.",
  "ai.playground.starters.label": "Experimente perguntar...",
  "ai.playground.starters.hint":
    "Clique em uma sugestão para enviar na hora.",
  "ai.playground.starters.companyFallback": "seu negócio",
  "ai.playground.starters.channel.whatsapp": "WhatsApp",
  "ai.playground.starters.channel.instagram": "Instagram",
  "ai.playground.starters.channel.messenger": "Messenger",
  "ai.playground.starters.prompt.company":
    "O que a {company} faz e quem é o cliente ideal?",
  "ai.playground.starters.prompt.knowledge.ready":
    "Quais informações você já conhece sobre a {company} a partir das minhas fontes de treinamento?",
  "ai.playground.starters.prompt.knowledge.missing":
    "Quais informações principais devo adicionar primeiro para você responder melhor sobre a {company}?",
  "ai.playground.starters.prompt.provider.ready":
    "Um cliente quer reservar. Como você o guiaria passo a passo?",
  "ai.playground.starters.prompt.provider.missing":
    "Se alguém quiser reservar agora, como você deve responder sem um provedor conectado?",
  "ai.playground.starters.prompt.channels.ready":
    "Mostre uma resposta ideal para a primeira mensagem recebida em {channels}.",
  "ai.playground.starters.prompt.channels.missing":
    "Escreva uma resposta inicial forte para uma nova pergunta de cliente.",
  "ai.playground.starters.prompt.context.whatIs": 'O que é "{topic}"?',
  "ai.playground.starters.prompt.context.tellMeMore":
    'Você pode me contar mais sobre "{topic}"?',
  "ai.playground.starters.prompt.context.howWorks":
    'Como "{topic}" funciona?',

  "ai.source.active": "Fonte ativa",
  "ai.source.inactive": "Fonte não configurada",
  "ai.sources.flow": "Como funciona o seu agente de IA",
  "ai.sources.flow.desc":
    "Suas fontes alimentam o agente. Ele usa suas regras e integrações para responder em todos os seus canais.",
  "ai.sources.agent": "Seu agente de IA",
  "ai.sources.agent.desc": "Centraliza, processa e responde.",
  "ai.sources": "Fontes de treinamento",
  "ai.sources.onboarding": "Treinar",
  "ai.sources.alert": "Treine sua IA",
  "ai.sources.alert.desc":
    "Adicione conteúdo para que seu agente aprenda sobre o seu negócio. Envie tudo em segundos: seu website, texto ou arquivos.",
  "ai.sources.alert.button": "Entendi",
  "ai.sources.desc":
    "Sua IA aprende com essas fontes para responder perguntas sobre o seu negócio.",
  "ai.sources.website": "Website",
  "ai.sources.website.desc":
    "Analise uma página da web para extrair seu conteúdo e usá-lo para melhorar sua IA",
  "ai.sources.website.scanning": "Análise do site em andamento",
  "ai.sources.website.scanning.info":
    "Estamos analisando seu site. Isso pode levar alguns minutos, mas enquanto isso, você pode adicionar mais fontes ou testar sua IA",
  "ai.sources.website.completed": "Análise do site concluída",
  "ai.sources.website.rescan.confirmation":
    "Tem certeza de que deseja escanear este site novamente?",
  "ai.sources.website.rescan.confirmationDesc":
    "Reescanear este site excluirá todo o conteúdo extraído anteriormente e o substituirá por novos dados da última análise",
  "ai.sources.website.delete.confirmation":
    "Tem certeza de que deseja excluir esta URL?",
  "ai.sources.website.delete.confirmationDesc":
    "Excluir esta URL removerá seu conteúdo da base de conhecimento do seu agente de IA. Ele não será mais usado para gerar respostas.",
  "ai.sources.website.fullCrawl":
    "Isso vai rastrear todos os links que comecem com a URL acima",
  "ai.sources.website.fullCrawlTitle": "Site completo",
  "ai.sources.website.singleCrawlTitle": "Página específica",
  "ai.sources.website.singleCrawl":
    "Isso vai extrair apenas o conteúdo da URL específica acima",
  "ai.sources.website.max":
    "Você atingiu o limite de {limit} URLs ativas. Exclua ou desative uma para adicionar outra",
  "ai.sources.text": "Texto",
  "ai.sources.text.desc":
    "Adicione texto livre para ensinar à sua IA novos detalhes ou esclarecer informações sobre o seu negócio",
  "ai.sources.text.tip.title":
    "Adicione o texto como se estivesse explicando para um colega.",
  "ai.sources.text.tip.examples":
    "Por exemplo:\n- Nosso horário de atendimento é de segunda a sexta, das 9h às 18h.\n- Para solicitar suporte, os clientes devem informar o número do pedido e o e-mail.",
  "ai.textHelp.title": "Sugestões de Conteúdo",
  "ai.textHelp.intro":
    "Este espaço é ideal para informações que não estão no seu site ou nos seus arquivos.",
  "ai.textHelp.faqs.title": "Perguntas Frequentes (FAQs)",
  "ai.textHelp.faqs.desc":
    "Copie e cole pares de Pergunta-Resposta que seus clientes sempre fazem.",
  "ai.textHelp.specific.title": "Dados Específicos",
  "ai.textHelp.specific.desc":
    "Listas de preços, horários de funcionamento, políticas de cancelamento.",
  "ai.textHelp.format.title": "Formatação Clara",
  "ai.textHelp.format.desc":
    "Use títulos e listas com marcadores. A IA entende melhor conteúdos bem estruturados.",
  "ai.textHelp.tip":
    "Dica: Você não precisa escrever como um humano. Dados diretos e brutos funcionam melhor.",
  "ai.instructionsHelp.title": "Definindo seu agente",
  "ai.instructionsHelp.intro":
    "Aqui você define a identidade e as regras do jogo. Pense nisso como a descrição de cargo do seu novo funcionário digital.",
  "ai.instructionsHelp.role.title": "Papel e objetivo",
  "ai.instructionsHelp.role.desc":
    'Diga quem ele é e o que deve alcançar. Exemplo: "Você é um concierge especialista em turismo e seu objetivo é vender passeios."',
  "ai.instructionsHelp.tone.title": "Tom de voz",
  "ai.instructionsHelp.tone.desc":
    "Como ele deve falar? Defina se prefere um tom formal e sério ou algo mais amigável e informal, com uso de emojis.",
  "ai.instructionsHelp.rules.title": "Regras e limites",
  "ai.instructionsHelp.rules.desc":
    'Defina regras e limites claros. Exemplo: "Nunca invente preços", "Responda sempre em espanhol", "Não fale sobre política."',
  "ai.instructionsHelp.tip":
    "Dica: Seja específico. Se quiser respostas curtas (com menos de 50 palavras), escreva isso explicitamente aqui.",

  "ai.sources.files": "Arquivos",
  "ai.sources.files.desc":
    "Envie arquivos para ensinar à sua IA. Sua IA não compartilhará esses arquivos - eles são usados apenas como base de conhecimento para gerar respostas",
  "ai.sources.files.upload": "Enviar Arquivo",
  "ai.sources.files.upload.label": "Envie uma imagem, PDF ou arquivo CSV",
  "ai.sources.files.delete": "Excluir Arquivo",
  "ai.sources.files.delete.confirmation":
    "Tem certeza de que deseja excluir este arquivo?",
  "ai.sources.files.delete.confirmationDesc":
    "Excluir este arquivo o removerá da base de conhecimento do seu agente de IA. Ele não será mais usado para gerar respostas.",
  "ai.sources.files.analyzed": "Arquivos Analisados",
  "ai.sources.files.limit": "O arquivo é muito grande. Limite: 15 MB",
  "ai.sources.files.max":
    "O limite de arquivos ativos é {limit}. Por favor, exclua ou desative um para poder enviar um novo arquivo",
  "ai.sources.providers": "Integrações",
  "ai.sources.providers.desc":
    "Conecte integrações externas para dar à sua IA acesso a dados adicionais e melhorar suas respostas.",
  "ai.sources.providers.manage":
    "Gerencie suas integrações conectadas na página de integrações. Você pode adicioná-las, atualizá-las ou removê-las a qualquer momento.",
  "ai.sources.providers.empty":
    "Nenhuma integração conectada ainda. Adicione uma na página de integrações para começar a usar dados externos",
  "ai.sources.providers.setUp": "Configurar uma Integração",
  "ai.sources.customerContext": "Contexto do Cliente",
  "ai.sources.customerContext.desc":
    "Adicione informações que só serão incluídas nas respostas quando uma reserva ou pedido for confirmado. Use isso para fornecer detalhes como números de quarto, senhas de Wi-Fi ou códigos de acesso especiais",
  "ai.sources.channels": "Canales",
  "ai.sources.channels.desc":
    "Conecte seu assistente aos principais canais e fontes de informação.",

  "ai.sidebar.sources": "Conhecimento",
  "ai.sidebar.behavior": "Comportamento",
  "ai.sidebar.connections": "Conexões",
  "ai.sidebar.agent.active": "Agente Ativo",
  "ai.sidebar.agent.active.desc": "Sua IA está pronta. Ir para o início.",
  "ai.sidebar.agent.setup": "Configure seu agente",
  "ai.sidebar.agent.setup.desc": "Adicione uma fonte.",
  "ai.home.improve.title": "Melhorar respostas",
  "ai.home.improve.subtitle":
    "Opcional, mas recomendado para melhorar qualidade e cobertura.",
  "ai.home.improve.knowledge.desc":
    "Treine sua IA com mais fontes de informação do negócio.",
  "ai.home.improve.integrations.desc":
    "Conecte provedores para enriquecer respostas baseadas em dados.",

  "ai.settings": "Configurações",
  "ai.settings.desc":
    "Ajuste o comportamento, a personalidade e as regras de escalonamento",
  "ai.settings.cta": "Configurações da IA",
  "ai.settings.instructions": "Regras e Tom",
  "ai.settings.instructions.desc":
    "Ajuste o tom e o comportamento do agente. Isso não adiciona conhecimento — apenas orienta como ele responde.",
  "ai.settings.escalations": "Escalações",
  "ai.settings.escalations.desc":
    "Defina quais situações acionam uma escalonamento. Se um usuário pedir ajuda ou enviar um comprovante de pagamento, a IA deixará de responder e sua equipe será notificada.",
  "ai.settings.escalations.enable": "Escalações ativas",
  "ai.settings.escalations.disabled": "Escalações desativadas",
  "ai.settings.escalations.disabled.alert":
    "Ative as escalonamentos para gerenciar suas regras personalizadas",
  "ai.settings.escalations.enable.desc":
    "Quando ativado, o agente de IA pausa sua resposta e notifica sua equipe sempre que uma regra for acionada.",
  "ai.settings.escalations.setup": "Configuração de escalonamentos",
  "ai.settings.escalations.setup.desc":
    "Escolha o que o agente de IA deve fazer em situações especiais.",
  "ai.settings.escalations.rules.name": "Nome da regra",
  "ai.settings.escalations.rules.content": "Palavra-chave / frase",
  "ai.settings.escalations.rules.add": "Adicionar regra",
  "ai.settings.escalations.rules.create": "Manter regra",
  "ai.settings.escalations.rules.new": "Nova regra de escalonamento",
  "ai.settings.escalations.rules.description": "Palavras-chave / Frase",
  "ai.settings.escalations.rules.details":
    "Digite uma palavra ou frase que o hóspede possa usar",
  "ai.settings.escalations.rules.build": "Regras integradas",
  "ai.settings.escalations.rules.custom": "Regras personalizadas",
  "ai.settings.escalations.rules.delete.title":
    "Tem certeza de que deseja excluir esta regra?",
  "ai.settings.escalations.rules.delete.desc":
    "Excluir esta regra impedirá que esse tipo de escalonamento seja acionado novamente",
  "ai.settings.workingHours": "Horário de atendimento",
  "ai.settings.workingHours.desc":
    "Se um escalonamento ocorrer fora deste horário, o agente de IA avisará o usuário que estamos offline antes de notificar sua equipe.",
  "ai.settings.workingHours.enable": "Horário de atendimento ativado",
  "ai.settings.workingHours.disabled": "Horário de atendimento desativado",
  "ai.settings.followUps": "Acompanhamentos inteligentes",
  "ai.settings.followUps.desc":
    "Envia acompanhamentos automáticos quando um usuário fica inativo. A IA analisa o contexto e só os envia quando for apropriado.",
  "ai.settings.followUps.enable": "Acompanhamentos ativados",
  "ai.settings.followUps.enable.desc":
    "Quando ativado, o agente de IA pode fazer acompanhamentos com usuários inativos, dependendo da situação.",
  "ai.settings.followUps.disabled": "Acompanhamentos desativados",
  "ai.settings.followUps.delay": "Tempo de acompanhamento",
  "ai.settings.followUps.delay.desc":
    "Escolha quanto tempo esperar antes de avaliar e enviar um acompanhamento.",
  "ai.settings.followUps.delay.option.half": "0.5h",
  "ai.settings.followUps.delay.option.hours": "{hours}h",
  "ai.settings.followUps.likelihood": "Probabilidade de acompanhamento",
  "ai.settings.followUps.likelihood.desc":
    "Controla o quão rigorosa a IA será antes de enviar um acompanhamento.",
  "ai.settings.followUps.likelihood.high": "Alta",
  "ai.settings.followUps.likelihood.default": "Padrão",
  "ai.settings.followUps.likelihood.low": "Baixa",
  "ai.settings.aiBookings.desc":
    "Gerencia reservas e pagamentos usando IA. Quando ativado, o agente de IA pode gerenciar reservas e pagamentos.",
  "ai.settings.aiBookings": "Reservas de IA",

  "ai.settings.aiBookings.enable": "Reservas de IA ativadas",
  "ai.settings.aiBookings.enable.desc":
    "Quando ativado, o agente de IA pode gerenciar reservas e pagamentos.",
  "ai.settings.aiBookings.disabled": "Reservas de IA desativadas",
  "ai.settings.aiBookings.connectedAccount": "Conta conectada do Stripe",
  "ai.settings.aiBookings.depositPercentage":
    "Depósito necessário como porcentagem do total da reserva (%). 100 significa pagamento total antecipado.",

  "account.successAdded":
    "O convite foi aceito e você agora tem acesso à conta.",
  "account.acceptInvitation.title": "Aceitar Convites",
  "account.acceptInvitation.pageDescription":
    "Por favor, aceite seus convites pendentes.",
  "account.acceptInvitation.account": "Nome da conta",
  "account.acceptInvitation.noPending":
    "Você não tem nenhum convite pendente...",

  "account.createAccount.title": "Criar uma nova conta",
  "account.createAccount.pageDescription":
    "Insira o nome da empresa para a nova conta",
  "channels.title": "Canais",
  "channels.account": "Conta",
  "channels.autoReplies": "Respostas automáticas de IA",
  "channels.waTitle": "Conecte os números de WhatsApp da sua empresa",
  "channels.waDescription":
    "Automatize conversas no WhatsApp ou responda manualmente no chat ao vivo",
  "channels.igTitle": "Conecte sua conta do Instagram",
  "channels.igDescription":
    "Automatize mensagens da caixa de entrada ou responda manualmente no chat ao vivo.",
  "channels.fmTitle": "Conecte o Facebook Messenger",
  "channels.fmDescription":
    "Automatize conversas no Messenger ou responda manualmente pelo app do Messenger.",
  "auth.title": "Seu agente de suporte com IA 24/7",
  "auth.description":
    "Resolva instantaneamente as dúvidas dos seus clientes no seu site, WhatsApp e Instagram com poderosos agentes de IA que você pode treinar em poucos minutos. Sem necessidade de código.",
  "auth.description.mobile":
    "Respostas instantâneas para seus clientes na web e no WhatsApp. Sem código. Pronto em minutos.",
  "auth.login.title": "Conecte-se",
  "auth.login.email": "E-mail",
  "auth.login.password": "Senha",
  "auth.login.login": "Entrar",
  "auth.login.registerLabel": "Novo no Visito?",
  "auth.login.register": "Criar uma conta",
  "auth.login.getAdemo": "Peça uma demonstração",
  "auth.login.forgotPassword": "Clique aqui",
  "auth.login.forgotLabel": "Esqueceu sua senha?",
  "auth.login.google": "Faça login com o Google",
  "auth.login.microsoft": "Faça login com o Microsoft",
  "auth.login.error": "E-mail ou senha inválidos",
  "auth.register.google": "Cadastre-se no Google",
  "auth.register.microsoft": "Cadastre-se no Microsoft",
  "auth.register.title": "Comece gratuitamente",
  "auth.register.company": "Nome da empresa",
  "auth.register.web": "Site",
  "auth.register.email": "E-mail",
  "auth.register.password": "Senha",
  "auth.register.register": "Registrar",
  "auth.register.loginLabel": "Já tem uma conta?",
  "auth.register.login": "Entrar",
  "auth.register.loginTerms": "Termos de Serviço",
  "auth.register.loginPrivacy": "Política de Privacidade",
  "auth.register.continuing": "Ao continuar, você aceita nossos",
  "auth.register.titleCloudbeds": "Crie sua conta Visito",
  "auth.registerUser.title": "Aceite seu convite",
  "auth.registerUser.subtitle":
    "Você está aceitando um convite para entrar no Visito. Crie sua conta para continuar.",
  "auth.registerUser.googleOption":
    "Crie sua conta com Google (o mesmo e-mail do convite).",
  "auth.registerUser.passwordOption": "Ou crie sua conta com uma senha.",
  "auth.registerUser.nextStepsTitle": "Próximos passos",
  "auth.registerUser.stepOne":
    "Escolha como deseja continuar: com Google ou com senha.",
  "auth.registerUser.stepTwo":
    "Se continuar com senha, crie-a e clique em Registrar.",
  "auth.registerUser.stepThree":
    "Se o Google abrir a conta errada, saia e escolha o e-mail do convite.",
  "auth.registerUser.error":
    "O e-mail que você está tentando usar para se registrar não corresponde ao da sua mensagem de convite",

  "auth.forgotPassword.title": "Redefinir senha",
  "auth.forgotPassword.email": "E-mail",
  "auth.forgotPassword.submit": "Enviar",
  "auth.forgotPassword.success":
    "O link para redefinir sua senha foi enviado para seu e-mail",
  "auth.forgotPassword.error":
    "E-mail não encontrado. Por favor, verifique e tente novamente.",
  "auth.forgotPassword.description":
    "Insira o endereço de e-mail associado à sua conta e enviaremos um link para redefinir sua senha.",
  "auth.resetPassword.title": "Redefinir sua senha",
  "auth.resetPassword.password": "Nova senha",
  "auth.resetPassword.cancel": "Cancelar",
  "auth.resetPassword.submit": "Redefinir",
  "auth.resetPassword.success":
    "Sua senha foi redefinida com sucesso. Agora você pode acessar sua conta usando a nova senha.",
  "auth.resetPassword.description": "Escolha uma nova senha abaixo.",
  "auth.userInvite.success": "Convite aceito com sucesso.",
  "contactDetail.header": "Informação",
  "contactDetail.title": "Perfil do contato",
  "contactDetail.leadInfo": "Informação do lead",
  "contactDetail.actions": "Atividade no chat",
  "contactDetail.bookings": "Reservas",
  "contactDetail.assignUser": "Atribuir usuário a este chat",
  "contactDetail.unassignUser": "Remover atribuição",
  "contactDetail.assignation": "Atribução de usuário",
  "contactDetail.followers": "seguidores",
  "contactDetail.toolCalls": "Atividade",
  "contactDetail.loadingChat": "Carregando mensagens...",
  "toolCalls.book": "Reserva oferecida",
  "toolCalls.help": "Peço ajuda",
  "toolCalls.manual": "Manual",
  "leads.datePlaceholder": "Data",
  "toolCalls.availability": "Reserva oferecida",
  "toolCalls.pricing": "Link de pagamento emitido",
  "toolCalls.payment_received": "Reserva gerada",
  "toolCalls.follow_up_after_inactivity": "Acompanhamento inteligente",
  "chats.newMessageInput": "Digite sua mensagem...",
  "chats.fileCaptionPlaceholder": "Adicione uma legenda...",
  "chats.searchContact": "Buscar contato",
  "chats.aiAuto":
    "Respostas automáticas de IA, se desativado, a IA não responderá automaticamente às mensagens recebidas.",
  "chats.markAsOpen": "Marcar como revisão",
  "chats.markAsClose": "Marcar como resolvido",
  "chats.assignation": "Atribuição",
  "chats.archive": "Arquivar chat",
  "chats.unArchive": "Desarquivar chat",
  "chats.archived": "Arquivados",
  "chats.all": "Todos",
  "chats.accounts": "Contas",
  "chats.enabled": "Manual",
  "chats.followUp": "Acompanhamento inteligente",
  "chats.blocked": "Bloqueado",
  "chats.reply": "Responder",
  "chats.filters": "Filtros",
  "chats.clone": "Clonar no playground",
  "chats.flag": "Reportar",
  "chats.isGuest": "Hóspede",
  "chats.isBook": "Reserva Oferecida",
  "chats.book": "Reserva Oferecida",
  "chats.isManual": "Conversa Manual",
  "chats.ai.isManual": "Conversa Manual",
  "chats.help": "Solicito ajuda",
  "chats.isConversion": "Conversão",
  "chats.outbound_conversion": "Outbound Conversion",
  "chats.payment_received": "AI Booking",
  "chats.isPayment": "Link de pagamento emitido",
  "chats.isBooked": "Reserva gerada",
  "chats.unblockContact": "Desbloquear Contato",
  "chats.blockContact": "Bloquear Contato",
  "chats.contactOptedOut": "O contato optou por sair",
  "chats.filter": "Filtrar",
  "chats.escalated": "Revisão",
  "chats.ad": "Anúncio",
  "chats.emptyStateTitle": "Ainda não há conversas",
  "chats.emptyStateSubtitle":
    "Sua lista de conversas está esperando pela primeira mensagem",
  "chats.emptyStateEscTitle": "Nenhuma conversa encontrada",
  "chats.emptyStateEscSubtitle": "Remova os filtros ou procure por um contato",

  "chats.emptyStatePendingTitle": "Nenhuma conversa necessita de sua ação",
  "chats.emptyStatePendingSubtitle":
    "Todas as conversas que necessitavam de sua ação foram resolvidas.",

  "chats.emptyWelcomeTitle": "Nenhuma conversa selecionada",
  "chats.emptyWelcomeSubtitle":
    "Escolha uma conversa à esquerda para visualizar as mensagens.",
  "chats.searchNoResults": "Nenhum resultado encontrado",
  "chats.searchStart": "Comece a digitar para encontrar um contato",
  "chats.bucket.all": "Todos",
  "chats.bucket.pending": "Requer revisão",
  "chats.bucket.mine": "Meus",
  "chats.bucket.mine.explanation": "Chats que você respondeu manualmente",
  "chats.bucket.pending.explanation":
    "Conversas escaladas pela IA que precisam de revisão",
  "chats.userMessage": "Mensagem do usuário",
  "chats.assistantResponse": "Resposta do bot",
  "chats.expectedResponse": "Resposta esperada",
  "chats.updateAnswer": "Reportar resposta incorreta",
  "chats.expectedResponsePlaceholder": "Escreva aqui a resposta ideal...",

  "chats.escalated.explanation":
    "Conversas que foram escaladas pela IA e precisam de revisão",

  "chats.isManual.explanation":
    "Conversas que incluem pelo menos uma resposta manual",

  "chats.enabled.explanation":
    "Conversas em que as respostas geradas por IA estão desativadas",
  "interactive.call.summary": "Resumo da chamada",
  "interactive.call.active": "Chat de voz ativo",
  "api.title": "Chaves da API",
  "api.subTitle": "Gerencie suas chaves da API",
  "api.description":
    "Confira nossa documentação completa sobre como usar a API.",
  "api.regenerate.warningTitle":
    "Tem certeza de que deseja regenerar esta chave de API?",
  "api.regenerate.warningDesc":
    "Regenerar a chave de API invalidará a chave atual, e você precisará atualizar suas aplicações de acordo.",
  "integrations.waSettings": "Configurações do WhatsApp",
  "integrations.waPaymentMethod": "Configurar pagamento",

  "integrations.title": "Integrações",

  "integrations.degradedStatus": "Erro na conexão",
  "integrations.alert.title": "Não disponível no seu plano",
  "integrations.alert.description":
    "O seu plano atual não permite o uso deste canal/integração. Para ativá-lo, atualize sua assinatura.",

  "integrations.alert.billing": "Atualizar plano",
  "integrations.alert.dismiss": "Entendi",

  "integrations.alert.wa.title": "Conectar o WhatsApp pode ser complicado",
  "integrations.alert.wa.description":
    "A Meta impõe regras rígidas para conectar um número do WhatsApp. Os problemas mais comuns incluem rejeição do número, necessidade de removê-lo do app e bloqueios inesperados. Recomendamos fortemente que leia nosso guia passo a passo ou agende uma chamada com nossa equipe. Você também pode continuar por conta própria, se preferir.",
  "integrations.alert.wa.guide": "Ler o guia",
  "integrations.alert.wa.button": "Agendar chamada de onboarding",
  "integrations.alert.wa.continue": "Continuar assim mesmo",

  "integrations.propertiesListTitle": "Propriedades",
  "integrations.noProperties": "Nenhuma propriedade encontrada",
  "integrations.embedChat": "Incorporar seu assistente virtual em seu site",
  "integrations.embedChatDescription":
    "Copie o código abaixo e cole no código-fonte do seu site.",
  "integrations.webChatLaunchTarget": "Ação da bolha",
  "integrations.webChatLaunchTargetDescription":
    "Escolha se a bolha abre o web chat ou redireciona para o WhatsApp.",
  "integrations.webChatLaunchWebchat": "Website chat",
  "integrations.webChatLaunchWhatsappPrefix": "WhatsApp",
  "integrations.webChatBubbleColor": "Cor da bolha",
  "integrations.webChatBubbleColorDescription":
    "Esta cor é aplicada à bolha do chat incorporado em todos os sites que usam esta chave de API.",
  "integrations.webChatWidgetDesktopSize": "Tamanho do widget (desktop)",
  "integrations.webChatWidgetMobileSize": "Tamanho do widget (mobile)",
  "integrations.webChatWidgetWidthPx": "Largura (px)",
  "integrations.webChatWidgetHeightPx": "Altura (px)",
  "integrations.webChatWidgetWidthVw": "Largura (vw)",
  "integrations.webChatWidgetHeightVh": "Altura (vh)",
  "integrations.webChatWidgetSizeDescription":
    "Desktop aceita largura 280-1000px e altura 400-1400px. Mobile aceita largura 50-100vw e altura 50-100vh.",

  "integrations.wordpress": "Plugin para WordPress",
  "integrations.wordpressInstructions":
    "Para usar o Visito AI no WordPress, siga estes passos:",
  "integrations.wordpressStep1": "Instale o plugin do Visito:",
  "integrations.wordpressStep2":
    "Ative o plugin e cole sua chave de API no painel do WordPress em Configurações > Visito AI.",
  "integrations.webChat": "Compatilhe seu assistente virtual",
  "integrations.webName": "Web Chat",
  "integrations.playName": "Playground Chat",
  "integrations.webChatDescription":
    "Copia o link abaixo para compartilhar seu assistente virtual com outras pessoas",
  "integrations.copyLink": "Copiar",
  "integrations.visitLink": "Abrir",
  "integrations.acceptNewIntegration":
    "Por favor, aceite a nova integração recebida do {provider}",
  "integrations.completedNewIntegration":
    "Você aceitou com sucesso a integração com o {provider}",

  "integrations.completedDbIntegration": "Integração adicionada com sucesso",
  "integrations.deleteTitle":
    "Tem certeza de que deseja excluir esta integração?",
  "integrations.deleteDesc":
    "Essa ação é irreversível. A integração será desativada imediatamente e você precisará reconectá-la se quiser usá-la novamente.",

  "integrations.webChatName": "Site Web",
  "integrations.fmName": "Messenger",
  "integrations.waName": "WhatsApp",
  "integrations.cbName": "Cloudbeds",
  "integrations.haName": "Hostaway",
  "integrations.igName": "Instagram",
  "integrations.smName": "SiteMinder",
  "integrations.gsName": "Guesty",
  "integrations.miraiName": "Mirai",
  "integrations.mwName": "Mews",
  "integrations.voiceName": "Voz",
  "integrations.shopName": "Shopify",
  "integrations.wpName": "WooCommerce",
  "integrations.wxName": "Wix Hotels",
  "integrations.hrName": "HotelRunner",

  "integrations.manualReplies": "A automação de IA está pausada.",
  "integrations.autoReplies": "A automação de IA está ativa.",

  "integrations.pmsActive": "Acesso está ativo.",
  "integrations.pmsPaused": "O acesso está pausado.",

  "integrations.igReconnect": "Adicione ou remova contas",
  "integrations.waReconnect": "Adicione ou remova números",
  "integrations.fmReconnect": "Adicione ou remova páginas",
  "integrations.wpReconnect": "Adicione ou remova lojas",
  "integrations.shopReconnect": "Adicione novas lojas",

  "integrations.cbReconnect": "Adicione novas propriedades",
  "integrations.smReconnect": "Adicione novas propriedades",
  "integrations.gsReconnect": "Adicione novas propriedades",
  "integrations.haReconnect": "Adicione novas propriedades",
  "integrations.mwReconnect": "Adicione novas propriedades",
  "integrations.wxReconnect": "Adicione novas propriedades",
  "integrations.hrReconnect": "Adicione novas propriedades",

  "integrations.smAdd": "Adicione uma nova propriedade do SiteMinder",
  "integrations.gsAdd": "Adicione uma nova propriedade do Guesty",
  "integrations.mwAdd": "Adicione uma nova propriedade do Mews",
  "integrations.voiceReconnect": "Adicione ou remova números de telefone",
  "integrations.wpAdd": "Adicione sua loja WooCommerce",
  "integrations.shopAdd": "Adicione uma nova loja Shopify",
  "integrations.wxAdd": "Adicione uma nova propriedade Wix Hotels",
  "integrations.hrAdd": "Adicione uma nova propriedade HotelRunner",
  "integrations.guide": "Guia de Integração",

  "integrations.missingInformation":
    "Sua integração está com informações faltando. Consulte o guia de integração e clique em ‘Gerenciar’ para completar as configurações da conta.",
  "integrations.nameDb": "Nome",
  "integrations.refreshTokenDb": "API Secret",
  "integrations.clientIdDb": "API Client ID",
  "integrations.integrationTokenDb": "Token de integracao",
  "integrations.propertyIdDb": "ID da Propriedade",
  "integrations.widgetIdDb": "ID do widget do motor de reservas",
  "integrations.publisherDb": "Publicador",
  "integrations.currencyDb": "Moeda",
  "integrations.countryCodeDb": "Selecione o país",
  "integrations.timezoneDb": "Fuso Horário",
  "integrations.bookingEngineDb": "Motor de Reservas",
  "integrations.xXsrfTokenDb": "X-Xsrf-Token",
  "integrations.xWixInstanceDb": "X-Wix-Instance",
  "integrations.wixBookingBaseUrlDb": "URL base de reservas Wix",
  "integrations.hotelrunnerApiKeyDb": "API key do HotelRunner",
  "integrations.hotelrunnerOTokenDb": "o_token do HotelRunner",
  "integrations.hotelrunnerONumberDb": "o_number do HotelRunner",
  "integrations.hotelrunnerChallengeDb": "X-HR-Challenge",
  "integrations.hotelrunnerBaseUrlDb": "URL base do HotelRunner",
  "integrations.phoneNumberDb": "Número de teléfono",
  "integrations.tokenDb": "Token de acesso",
  "integrations.websiteDb": "URL do site",

  "integrations.nameDbPlaceholder": "Hotel Santa Fé",
  "integrations.integrationTokenDbPlaceholder":
    "Cole seu token de integracao da Guesty (uso unico, expira em 4 horas)",
  "integrations.propertyIdDbPlaceholder": "28093",
  "integrations.widgetIdDbPlaceholder": "santafedirect",
  "integrations.publisherDbPlaceholder": "littlehotelier",
  "integrations.currencyDbPlaceholder": "BRL",
  "integrations.countryCodeDbPlaceholder": "BR",
  "integrations.phoneNumberDbPlaceholder": "5585655477",
  "integrations.tokenDbPlaceholder": "shpat_*****************************",
  "integrations.websiteDbPlaceholder": "https://mystore.com",
  "integrations.xXsrfTokenDbPlaceholder": "1775664531|KKHB0gLdhXRI",
  "integrations.xWixInstanceDbPlaceholder": "eyJpbnN0YW5jZUlkIjoi...",
  "integrations.wixBookingBaseUrlDbPlaceholder": "https://www.myhotel.com/rooms",
  "integrations.hotelrunnerApiKeyDbPlaceholder":
    "7518391247a27ce412d421ffe241c6ffd3f52e7c4b26e993",
  "integrations.hotelrunnerOTokenDbPlaceholder":
    "a8c4516976fe2feffcbe173925822c7c",
  "integrations.hotelrunnerONumberDbPlaceholder": "R076950164",
  "integrations.hotelrunnerChallengeDbPlaceholder": "609402",
  "integrations.hotelrunnerBaseUrlDbPlaceholder":
    "https://sua-propriedade.hotelrunner.com",

  "integrations.refreshTokenDbPlaceholder":
    "Your API secret from guesty API dashboard",
  "integrations.clientIdDbPlaceholder":
    "Your Client ID from guesty API dashboard",

  "integrations.pageTitle": "Integrações",
  "integrations.pageConnectTitle": "Canais",
  "integrations.pageDescription":
    "Conecte seu assistente aos principais canais de comunicação e fontes de dados",

  "integrations.fmDescription": "Conecte suas páginas do Facebook",
  "integrations.waDescription": "Conecte seu número de WhatsApp",
  "integrations.cbDescription": "Conecte suas propriedades do Cloudbeds",
  "integrations.haDescription": "Conecte suas propriedades do Hostaway",
  "integrations.igDescription": "Conecte suas contas do Instagram",
  "integrations.smDescription": "Conecte suas propriedades do SiteMinder",
  "integrations.gsDescription": "Conecte suas propriedades do Guesty",
  "integrations.shopDescription": "Conecte sua loja Shopify",
  "integrations.wpDescription": "Conecte sua loja WooCommerce",
  "integrations.miraiDescription": "Conecte seu motor de reservas do Mirai",
  "integrations.mwDescription": "Conecte suas propriedades do Mews",
  "integrations.voiceDescription": "Conecte seu número de telefone",
  "integrations.wxDescription": "Conecte suas propriedades do Wix Hotels",
  "integrations.hrDescription": "Conecte suas propriedades do HotelRunner",

  "teams.title": "Gerenciamento de Equipe",
  "teams.subTitle": "Gerencie o acesso dos membros da equipe",
  "teams.inviteMember": "Convide um novo membro da equipe",
  "teams.selectorLabel": "Papel",
  "teams.rol.admin": "Administrador",
  "teams.rol.user": "Usuário",
  "teams.emailLabel": "E-mail",
  "teams.button": "Convidar",
  "teams.message.success": "Um link de convite foi enviado para o seu e-mail.",
  "teams.passwordLabel": "Senha",
  "teams.buttonAccept": "Aceitar",
  "teams.inviteInfo": "Aceitar convite de equipe",
  "teams.modalMessageTitle.success": "Convite enviado com sucesso",
  "teams.modalMessageTitle.error": "Erro ao enviar o convite",
  "teams.modal.button": "Fechar",
  "invitedList.Members": "Lista de membros da equipe",
  "invitedList.Invites":
    "{count, plural, one {# convite restante} other {# convites restantes}}",
  "invitedList.emailLabel": "E-mail",
  "invitedList.roleLabel": "Papel",
  "invitedList.dateLabel": "Ingressou em",
  "invitedList.title.deleteSuccess": "Remover usuário",
  "invitedList.message.deleteSuccess": "Usuário removido com sucesso",
  "invitedList.message.deleteError": "Erro ao remover o usuário",
  "payment.title": "Cobrança",
  "payment.subTitle":
    "Gerencie seus métodos de pagamento, assinaturas e detalhes de cobrança.",
  "payment.monthly": "Mensal",
  "payment.annual": "Anual",
  "payment.billingCycle": "Ciclo de cobrança",
  "payment.currentPlan": "Plano atual",
  "payment.changePlan": "Mudar para este plano",
  "payment.changePlanPayNow": "Mudar para este plano e pagar agora",
  "payment.managePlan": "Gerenciar pagamento",
  "payment.billingEmail": "E-mail de cobrança",
  "payment.selectAPlan": "Selecione um plano",
  "payment.manageCurrentPlan":
    "Gerencie seu plano - altere ou faça upgrade para aumentar seus limites",
  "payment.noPlanAlert":
    "Você não está inscrito em nenhum plano. Assine um plano para aumentar seus limites.",
  "payment.planTier":
    "{credits, number} créditos de mensagens - {price, number, ::currency/USD}/mês",
  "payment.planTierMonthly":
    "{credits, number} créditos de mensagens - {price, number, ::currency/USD}/mês",
  "payment.planTierAnnual":
    "{credits, number} créditos de mensagens - {price, number, ::currency/USD}/ano",
  "payment.subscribe": "Assinar este plano",
  "payment.downgradeScheduled": "Downgrade agendado para {date}",
  "payment.pendingDowngrade": "Downgrade pendente em {date}",
  "payment.currentPlanUntil": "Plano atual: {plan} até {date}",
  "payment.scheduledPlanFrom": "Plano agendado: {plan} a partir de {date}",
  "payment.scheduledPlan": "Plano agendado (inicia em {date})",
  "payment.planNoop": "Você já está neste plano",
  "payment.planNoopCurrent": "Você já está neste plano atual",
  "payment.planNoopScheduled": "Este downgrade já está agendado para {date}",
  "payment.portalError":
    "Não foi possível abrir o portal de cobrança, tente novamente mais tarde",
  "usage.title": "Uso",
  "usage.customRangeTitle": "Intervalo de datas personalizado",
  "usage.subTitle":
    "Acompanhe o consumo diário de créditos faturáveis no seu ciclo atual",
  "usage.filterBillingCycle": "Ciclo de cobrança atual",
  "usage.kpiTotal": "Total de créditos faturáveis",
  "usage.kpiAverage": "Média por dia",
  "usage.kpiPeak": "Pico diário",
  "usage.empty":
    "Ainda não há atividade de créditos faturáveis neste período. Volte mais tarde.",
  "usage.error":
    "Não foi possível carregar os dados de uso agora. Tente novamente em instantes.",
  "usage.axisCredits": "Créditos",
  "usage.creditsUsed": "créditos usados",
  "usage.seriesBillable": "Créditos faturáveis",
  "language.title": "Idioma",
  "language.subTitle": "Selecione o idioma que deseja usar na plataforma",
  "language.selectorLabel": "Selecionar Idioma",
  "language.english": "English",
  "language.spanish": "Español",
  "language.portuguese": "Português",
  "language.languages": "Idiomas",
  "language.en_US": "Inglês",
  "language.es_MX": "Espanhol",
  "language.pt_BR": "Português",
  "home.statsTitle": "Estatísticas dos últimos 30 dias",
  "home.planTitle": "Estatísticas do plano atual",
  "home.pageTitle": "Olá",
  "home.pageDescription": "Bem-vindo ao seu painel do Visito",
  "home.skip": "Pular introdução",

  "home.onboardingTitle": "Começar",
  "home.onboardingDescription":
    "Conclua as etapas abaixo para configurar totalmente sua conta",

  "home.title_account": "Crie sua conta",
  "home.description_account":
    "Gerencie todas as comunicações em uma única caixa de entrada do Visito",

  "home.title_location": "Conecte uma propriedade",
  "home.description_location": "Integre sua propriedade ao Visito",

  "home.title_channel": "Conecte um canal",
  "home.description_channel":
    "Conecte um canal para começar a receber mensagens",

  "home.title_wa": "Conecte o WhatsApp",
  "home.description_wa":
    "Alcance mais de 2 bilhões de clientes em todo o mundo",

  "home.title_fm": "Conecte o Facebook Messenger",
  "home.description_fm": "Melhore o suporte e as reservas com o Messenger",

  "home.title_ig": "Conecte o Instagram",
  "home.description_ig":
    "Conecte a caixa de entrada da sua conta do Instagram para começar a receber mensagens",

  "home.messageLimit": "Créditos de mensagens restantes",
  "home.messageResetDate": "Data de reinicialização",
  "home.remainingQuotaOutOf": "{remaining} restantes de {limit}",
  "home.descriptionLimit":
    "{count, plural, um {# mensagen disponívei} other {# mensagens disponíveis}} de {messageLimit, number}",
  "home.dateLimit": "Se restabelece em {date}",
  "home.increaseLimit": "Plano de atualização",
  "home.limitReached": "Limite atingido",
  "home.nearLimit": "Perto do limite",
  "home.quotaLeft": "Créditos: {remaining} / {total} ({pct}%)",
  "home.trialBadge": "Teste · {days}d restantes",
  "home.trialEndsOn": "O teste termina em {date}",
  "home.trialNoticeTitle": "Teste grátis ativo",
  "home.trialNoticeBody":
    "Seu cartão será cobrado em {date}, a menos que você cancele antes.",
  "home.trialNoticeCta": "Gerenciar cobrança",
  "home.plentyLeft": "Ainda há muito para usar",
  "home.messagesUnderReview": "Mensagens em revisão",
  "home.unreadManualMessages": "Mensagens manuais não lidas",
  "home.links": "Links rápidos",
  "home.planUsageHelper": "Restante",
  "home.requiresAction": "Mensagens que requerem a sua ação",

  "home.title_ai": "Configure as fontes de dados da sua IA",
  "home.description_ai": "Programe seu agente de IA com as informações certas",
  "home.pendingItems": "itens pendentes",
  "home.uniqueContacts": "Contatos Únicos",
  "home.totalMessages": "Mensagens Totais",
  "home.percentageAuto": "Resoluções por IA (%)",
  "home.noStats":
    "Parece que ainda não há dados. Por favor, volte mais tarde ou ajuste seus filtros.",
  "home.maintenance": "Voltamos em breve 🛠️",
  "home.maintenance.desc":
    "Estamos fazendo algumas melhorias para oferecer um serviço ainda melhor. Todas as suas informações estão seguras e logo estaremos de volta",
  "home.updateApp": "Atualização necessária",
  "home.updateApp.desc":
    "Uma nova versão ({remoteVersion}) está disponível. Atualize o aplicativo para continuar.",
  "home.updateApp.btn": "Atualize agora",

  "leads.intent": "Resumo da conversa",
  "leads.score": "Interesse",
  "leads.filter.actions": "Atividade no chat",
  "leads.high": "Alta",
  "leads.medium": "Média",
  "leads.low": "Baixa",
  "leads.no_score": "-",
  "leads.filter.company": "Filtrar conta",
  "leads.stats.book": "Disponibilidade",
  "leads.stats.pricing": "Link de pagamento emitido",
  "leads.stats.payment_received": "Reservou",
  "leads.stats.payment_receivedExplanation":
    "Reserva concluída e paga durante a conversa",
  "leads.followUp": "Acompanhamentos",
  "leads.stats.availability": "Disponibilidade",
  "leads.stats.help": "Solicito ajuda",
  "leads.stats.paid": "Pago",
  "leads.stats.opt_in": "Opted in",
  "leads.stats.arrival_time": "Hora de chegada",
  "leads.stats.availabilityExplanation": "Disponibilidade solicitada no chat.",
  "leads.stats.confirm": "Confirmadas",
  "leads.stats.postConfirm": "Confirmadas",
  "leads.stats.reservation_details": "Eu pergunto detalhes",
  "leads.stats.rating": "Qualificou-se",
  "leads.stats.generate_payment_link": "Eu gero uma liga pay-per-view",
  "leads.stats.postConfirmError": "Algo deu errado",
  "leads.stats.total": "Todo",
  "leads.pageTitle": "Leads",
  "leads.pageDescription": "Clientes em potencial que iniciaram uma conversa",
  "leads.isBook": "Disponibilidade solicitada",
  "leads.isPayment": "Link de pagamento gerado",
  "leads.isBooked": "Reserva concluídad",
  "leads.escalated": "marcado para revisão",
  "leads.isManual": "Respondido manualmente",
  "leads.help": "Solicito ajuda",
  "leads.export": "Exportar",
  "leads.noScoreExplanation": "Pontuação ainda não disponível",
  "leads.followUpStatus.no_follow_up": "-",
  "leads.followUpStatus.pending": "Em avaliação",
  "leads.followUpStatus.followed_up": "Enviado",
  "leads.followUpStatus.rejected": "Não recomendado",
  "leads.followUpStatus.howManySent": "{count} enviados",

  //No follow-ups.
  "leads.followUpStatus.no_follow_upExplanation": "Sem acompanhamento.",
  "leads.followUpStatus.pendingExplanation":
    "A IA está avaliando se é necessário enviar um acompanhamento com base na última interação do usuário. {count, plural, =0 {} other {Já foram enviados {count} acompanhamento(s).}}",
  "leads.followUpStatus.followed_upExplanation":
    "A IA enviou uma mensagem de acompanhamento para retomar o contato com o usuário. {count, plural, one {Um acompanhamento foi enviado.} other {{count} acompanhamentos foram enviados.}}",
  "leads.followUpStatus.rejectedExplanation":
    "A IA decidiu que não era necessário fazer um acompanhamento. {count, plural, =0 {} one {Um acompanhamento já havia sido enviado.} other {{count} acompanhamentos já haviam sido enviados.}}",

  "leads.noIntent": "-",
  "leads.noLeads": "Nenhum lead encontrado",
  "leads.noIntentExplanation":
    "A IA ainda não identificou a intenção do usuário nesta conversa. A informação será atualizada após a análise da conversa.",
  "leads.date": "Última mensagem",
  "leads.payments.date": "Data",
  "leads.payments.pageTitle": "Pagamentos",
  "leads.payments.bookings": "Reservas",
  "leads.payments.reference": "Referência",
  "leads.payments.status": "Status",
  "leads.payments.amount": "Valor",
  "leads.payments.pending": "Pendente",
  "leads.payments.transfered": "Transferido",
  "leads.payments.paymentBreakDown": "Detalhes do Pagamento",
  "leads.payments.makeArefund": "Reembolsar",
  "leads.payments.paymentRequested": "Pagamento solicitado",
  "leads.payments.commission": "Comissão do Visito",
  "leads.payments.fees": "Taxas do Stripe",
  "leads.payments.netAmount": "Subtotal",
  "leads.payments.providerNetAmount": "Total",
  "leads.payments.refunded": "Reembolsado",
  "leads.payments.transferStatus": "Status da Transferência",
  "leads.payments.pendingTransfer": "Pendente de transferência",
  "leads.payments.expired": "Expirado",
  "leads.payments.active": "No pago",
  "leads.payments.paid": "Pago",
  "leads.payments.refunds": "Reembolsos",
  "leads.payments.reconciled": "Conciliado",
  "leads.payments.transferFunds": "Executar transferência",
  "leads.payments.hydrateBalance": "Executar hidratação de saldo",
  "leads.payments.viewConversation": "Ver conversa",
  "leads.payments.refundPayment": "Reembolsar pagamento",
  "leads.payments.refundAmount": "Valor do reembolso",
  "payments.stripe.title": "Pagamentos com Stripe Express",
  "payments.stripe.connectMessage":
    "Conecte sua conta bancária para começar a receber pagamentos no chat dos seus hóspedes.",
  "payments.stripe.landingHeadline":
    "Comece a receber pagamentos no chat para o seu negócio",
  "payments.stripe.landingSubheadline":
    "Conecte sua conta bancária para cobrar no chat por produtos, serviços ou reservas em um só lugar.",
  "payments.stripe.docsInChatPayments": "Docs de pagamentos no chat",
  "payments.stripe.docsItemsCatalog": "Docs de catálogo de itens",
  "payments.stripe.connect": "Conectar conta bancária",
  "payments.stripe.connectedAccount": "Conta conectada: {account}",
  "payments.stripe.itemsToggleLabel": "Ativar cobrança de itens no chat",
  "payments.stripe.itemsToggleHelp":
    "Permite que a IA gere links de pagamento para itens do seu catálogo.",
  "payments.stripe.payoutsToggle":
    "Ativar cobrança de pagamentos no chat (em vez de redirecionar para o motor de reservas)",
  "payments.stripe.depositPercentageLabel": "Depósito a cobrar no chat",
  "payments.stripe.depositPercentageHelp":
    "Escolha entre 1% e 100% do valor total da reserva.",
  "payments.stripe.openExpress": "Abrir Stripe Express",
  "payments.stripe.disconnect": "Desconectar",
  "payments.stripe.disconnectSuccess": "Conta Stripe desconectada",
  "payments.items.title": "Catálogo de itens",
  "payments.items.subtitle":
    "Crie produtos ou serviços que a IA pode cobrar diretamente no chat.",
  "payments.items.name": "Nome",
  "payments.items.namePlaceholder": "Ex.: Day pass",
  "payments.items.description": "Descrição",
  "payments.items.descriptionPlaceholder":
    "Ex.: Acesso de dia inteiro à piscina e às instalações",
  "payments.items.price": "Preço",
  "payments.items.pricePlaceholder": "Ex.: 20.00",
  "payments.items.currency": "Moeda",
  "payments.items.active": "Item ativo",
  "payments.items.propertiesTitle": "Detalhes do item",
  "payments.items.propertiesSubtitle":
    "Capture detalhes de cada venda (data, opção, observações etc.).",
  "payments.items.addProperty": "Adicionar detalhe",
  "payments.items.propertiesEmpty": "Nenhum detalhe configurado.",
  "payments.items.propertyLabel": "Nome do detalhe",
  "payments.items.propertyLabelPlaceholder": "Ex.: Dia",
  "payments.items.propertyType": "Tipo de detalhe",
  "payments.items.propertyRequired": "Detalhe obrigatório",
  "payments.items.propertyType.date": "Data",
  "payments.items.propertyType.enum": "Lista",
  "payments.items.propertyType.text": "Texto",
  "payments.items.propertyType.number": "Número",
  "payments.items.propertyEnumOptions": "Opções da lista",
  "payments.items.propertyEnumOptionPlaceholder": "Ex.: Massagem relaxante",
  "payments.items.propertyAddOption": "Adicionar opção",
  "payments.items.propertiesCount":
    "{count, plural, one {# detalhe} other {# detalhes}}",
  "payments.items.docs": "Docs",
  "payments.items.create": "Criar item",
  "payments.items.update": "Atualizar item",
  "payments.items.cancelEdit": "Cancelar edição",
  "payments.items.empty": "Nenhum item criado ainda.",
  "payments.items.statusActive": "Ativo",
  "payments.items.statusInactive": "Inativo",
  "payments.items.edit": "Editar",
  "payments.items.deactivate": "Desativar",
  "payments.items.delete": "Excluir",
  "payments.items.deleteConfirm": "Excluir este item?",
  "payments.items.validationError":
    "Preencha nome, preço, moeda e detalhes válidos antes de salvar.",
  "payments.tabs.stripeAccount": "Conta Stripe",
  "payments.tabs.bookingSettings": "Configurações de reservas",
  "payments.tabs.itemSettings": "Configurações de itens",
  "payments.booking.connectStripeFirst":
    "Conecte primeiro sua conta Stripe para configurar as reservas.",
  "leads.payments.itemProperties": "Detalhes do item",
  "outbound.event": "Evento",
  "outbound.pageTitle": "Eventos",
  "outbound.pageDescription":
    "Melhore o engajamento dos hóspedes com gatilhos de comunicação automatizados ao longo da jornada de reserva",
  "outbound.viewEvent": "Ver evento",
  "outboud.messagesSent": "Mensagens enviadas nos últimos 30 dias",
  "outbound.reservation":
    "Após o hóspede concluir sua reserva, ele recebe uma mensagem de confirmação com os detalhes da reserva.",
  "outbound.time_reservation": "Enviado imediatamente",
  "outbound.arrival":
    "Antes da chegada, o hóspede recebe uma mensagem com informações úteis sobre a estadia.",
  "outbound.time_arrival": "2 dias antes da chegada",
  "outbound.stay":
    "Após o check-in do hóspede, ele recebe uma mensagem com instruções especiais e informações úteis",
  "outbound.time_stay": "Enviado imediatamente após a chegada",
  "outbound.after_departure":
    "Após o check-out do hóspede, ele recebe uma mensagem de agradecimento junto com um pedido de feedback.",
  "outbound.time_after_departure": "Após o status mudar para 'check-out'",
  "outbound.inactiveTitle": "Tem certeza de que deseja desativar este evento?",
  "outbound.inactiveDesc":
    "Desativar este evento fará com que as respostas não sejam enviadas",
  "outbound.disabling": "Desativando evento...",
  "outbound.cardTitle": "Eventos de saída",
  "outbound.recentActivity": "Atividade recente",
  "outbound.noActivity": "Sem atividade",
  "outbound.missingChannel":
    "Ops! Você ainda não conectou um número de WhatsApp à sua conta.",
  "outbound.missingChannelDesc":
    "Conecte seu número de WhatsApp para interagir com seus hóspedes durante as reservas, chegadas e após a partida.",
  "outbound.missingChannelCTA": "Clique aqui para conectar",
  "outbound.modifyTemplate": "Modificar modelo",
  "outbound.templateTitle": "Editar {template} ",
  "outbound.templateLastUpdate":
    "Última modificação: {date} (Modificado {count, plural, one {# vez} other {# vezes}} em 30 dias)",
  "outbound.templateLangDesc":
    "Modifique a mensagem que deseja enviar aos hóspedes em {lang}",
  "outbound.templatePreview": "Pré-visualizar mensagem",
  "outbound.templatePreviewDesc": "Abaixo está como sua mensagem será exibida",
  "outbound.templateVarsInfo":
    "Certifique-se de que as tags foram inseridas corretamente. Consulte abaixo quais tags você pode usar",
  "outbound.templateVardDesc": "Use essas tags no corpo da mensagem",
  "outbound.templateTag": "Tag",
  "outbound.templateFunction": "Função",
  "outbound.template_confirmationId": "Número de confirmação",
  "outbound.template_username": "Nome completo do contato",
  "outbound.template_checkin": "Data de check-in do hóspede",
  "outbound.template_checkout": "Data de check-out do hóspede",
  "outbound.template_status_PENDING":
    "As novas alterações no modelo estão em revisão. Isso pode levar até 24 horas para aprovação. Você não poderá modificar o modelo enviado até que a revisão seja concluída.",
  "outbound.template_status_REJECTED":
    "Suas alterações foram rejeitadas pelo seguinte motivo: {reason}",
  "outbound.template_status_LESS_THAN_ONE_DAY":
    "Aguarde 24 horas desde a última atualização para editar o modelo novamente",
  "outbound.templateReviewTitle":
    "Tem certeza de que deseja enviar essas novas alterações para revisão?",
  "outbound.templateReviewDesc":
    "O envio para revisão pode levar até 24 horas para ser aprovado. Você ficará bloqueado de fazer mais alterações.",
  "outbound.templateSend": "Sim, enviar para revisão",
  "outbound.templateSendForReview":
    "O modelo foi enviado para revisão, o processo de aprovação pode levar até 24 horas",
  "outbound.template_review_url_Desc":
    "Este link será incluído se a avaliação for positiva",
  "outbound.template_review_url": "Link para avaliações positivas",
  "outbound.template_review_url_Placeholder":
    "https://tripadvisor.com/review/example",
  "outbound.templateNoLang": "Idioma indisponível",
  "outbound.templateNoLangDescription": "Adicione esse idioma para começar",
  "outbound.isLanguageActive": "Idioma ativo?",
  "onboarding.getStarted": "Começar",
  "onboarding.pageTite": "Introdução",
  "onboarding.stepsTitle":
    "Escolha um horário para concluir sua introdução ao Visito",
  "onboarding.step1":
    "Revise as informações da sua propriedade e as configurações do chat",
  "onboarding.step2":
    "Configure seus canais de comunicação, incluindo WhatsApp e Instagram",
  "onboarding.step3": "Visão geral dos recursos e capacidades da conta",
  "onboarding.step4":
    "Envie mensagens de teste e habilite o Visito em suas propriedades digitais",
  "onboarding.step5": "Responda a quaisquer outras dúvidas que você possa ter!",

  "onboarding.businessInfo": "Detalhes do seu negócio",
  "onboarding.businessInfoWorking":
    "Quase lá! Isso deve levar menos de um minuto...",
  "onboarding.businessInfoDone": "Tudo pronto.",
  "onboarding.businessInfoContinue":
    "Revise as informações e continue. Você sempre pode editar isso mais tarde.",
  "onboarding.channelsDone": "Tudo pronto!",
  "onboarding.continueToDashboard": "Continue para o painel",
  "onboarding.igConnect": "Conecte sua conta automaticamente.",
  "onboarding.igConnected": "Sua conta do Instagram foi conectada.",

  "onboarding.waConnect": "Comece em minutos.",
  "onboarding.waConnected": "Seu número de telefone do WhatsApp foi conectado.",
  "onboarding.channelsTitle": "Conecte Instagram ou WhatsApp para começar:",

  "newConv.Title": "Criar uma nova conversa",
  "newConv.Desc":
    "Insira o número do WhatsApp e a mensagem abaixo para criar uma nova conversa",
  "newConv.invalidPhone": "Parece que você inseriu um número incorreto.",
  "newConv.success": "Mensagem enviada com sucesso",
  "newConv.invalidFile": "O arquivo é inválido",

  "webchat.welcome": "Olá! 👋{linebreak}Como podemos te ajudar hoje?",
  "webchat.callPrompt": "Fale com {company}",
};

export default lang;
